import { EventBus } from '../../../eventBus.js'

export default {
    methods: {
        updateCardVisibility(id, canShow) {
            const card = this.cards.find((card) => card.id === id)
            if (card) card.canShow = canShow
        },

        handleCardAction(card) {
            if (this.selectedCard?.id === card.id && this.showPanel) return
            this.selectedCard = { ...card }
            this.showPanel = true
        },

        updateEstablishment(updatedData) {
            let isSameBillingAddress = updatedData?.is_same_billing_address ?? true
            if (this.selectedCard?.id === 3) {
                this.updateCardVisibility(4, !isSameBillingAddress)
            }
            Object.assign(this.establishment, updatedData)
            this.$store.commit('establishment/UPDATE_ESTABLISHMENT', updatedData)
        },

        async closePanel(showMessage = true) {
            try {
                const formComponent = this.$refs.activeForm
                // console.log('formComponent', formComponent)
                // if (formComponent?.getFormData) {
                //     console.log('getFormData exists')
                //     const formData = formComponent.getFormData()
                //     Object.assign(this.establishment, formData)
                await this.submitForm(showMessage)
                // }
            } catch (error) {
                console.error('Error saving establishment:', error)
            } finally {
                this.showPanel = false
                this.selectedCard = null
            }
        },

        convertToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = reject
                reader.readAsDataURL(file)
            })
        },

        async submitForm(showMessage = true) {
            const websiteSettingFiltered = this.$store.getters['establishment/websiteSetting'].filter((item) => item.parameter)

            const appSettingFiltered = this.$store.getters['establishment/appSetting']

            const establishmentCancelRate = this.$store.getters['establishment/establishmentCancelRate']

            const modificationPolicy = this.$store.getters['establishment/establishmentModificationPolicy']

            const establishment = { ...this.$store.getters['establishment/establishment'] }

            if (typeof establishment.map_coords === 'string') {
                try {
                    establishment.map_coords = JSON.parse(establishment.map_coords)
                } catch (error) {
                    console.warn('Invalid JSON in map_coords:', establishment.map_coords)
                    establishment.map_coords = null
                }
            }

            const fieldsToConvert = [
                { source: 'logo', target: 'logo_base64', label: 'logo' },
                { source: 'photo', target: 'photo_base64', label: 'bannière' },
            ]

            for (const field of fieldsToConvert) {
                if (establishment[field.source] instanceof File) {
                    establishment[field.target] = await this.convertToBase64(establishment[field.source])
                    delete establishment[field.source]
                }
            }

            try {
                const payload = {
                    id: establishment.id,
                    establishment,
                    appSetting: appSettingFiltered,
                    websiteSetting: websiteSettingFiltered,
                    establishmentCancelRate: establishmentCancelRate,
                    step: this.selectedCard?.key,
                }

                if (modificationPolicy) {
                    payload.modificationPolicy = modificationPolicy
                }

                if (this.selectedCard?.key === 'PaymentMethods') {
                    payload.selectedPaymentMethods = this.$store.getters['establishment/paymentMethodsSelectedIds']
                }

                const data = await this.$store.dispatch('establishment/updateEstablishment', payload)

                if (showMessage) {
                    this.$toast.success(this.$t('common.config_updated_success'))
                }

                EventBus.$emit('establishment-settings-updated')
                this.showPanel = false
            } catch (error) {
                this.showErrors(error)
            }
        },

        showErrors(response) {
            if (response && response.response && response.response.data && response.response.data.errors) {
                const errors = response.response.data.errors

                for (const key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        const errorMessage = errors[key][0]
                        this.showErrorNotification(errorMessage)
                    }
                }
            } else if (response && response.response && response.response.data && response.response.data.message) {
                this.showErrorNotification(response.response.data.message)
            } else {
                this.showErrorNotification('An error occurred. Please try again.')
            }
        },

        showErrorNotification(message) {
            this.$toast.error(message)
        },
    },
}
